import React from "react";
import { Heading1, Heading2, TextContainer } from "./Login.styles";

const LoginLeftContainer = () => {
  return (
    <TextContainer>
      <Heading1>MUSIC DASHBOARD</Heading1>
      <Heading2>Welcome to the official ROVR curation dashboard! </Heading2>
      <Heading2>
        This is where you can access your dedicated curation space and run your
        program. One place to easily upload, organize and review every playlist
        for all your shows.
      </Heading2>
      <Heading2>Let’s get started!</Heading2>
    </TextContainer>
  );
};

export default LoginLeftContainer;
